// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero_wrapper__W89Gx","backgrounds":"Hero_backgrounds__13EBG","item":"Hero_item__eiyHs","isActive":"Hero_isActive__1r1o3"};